import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {headers} from "./headers";
import {AIProviderSettings} from "../../ai/providers/AIProvider";
import {host} from "./api";


export interface AiState {
    aiProviderSettings: AIProviderSettings[]
    projectAiProviderSettings: AIProviderSettings[]
}

const initialState: AiState = {
    aiProviderSettings: [],
    projectAiProviderSettings: []
}

export const loadAiSettings = createAsyncThunk('loadSettings', async () => {
    const response = axios.get(`${host}/ai/providers`, {
        headers: headers(undefined)
    })
    return response.then((response) => response.data)
})

export const loadProjectAiProviders = createAsyncThunk('loadProjectAiProviders', async (params: {
    projectId: string | undefined
}) => {
    const response = axios.get(`${host}/ai/project/providers`, {
        headers: headers(params.projectId)
    })
    return response.then((response) => response.data)
})

export const saveAiSettings = createAsyncThunk('saveSettings', async (params: { settings: AIProviderSettings[] }) => {
    const response = axios.post(`${host}/ai/providers`, params.settings, {
        headers: headers(undefined)
    })
    return response.then((response) => response.data)
})


export const saveProjectAiProviders = createAsyncThunk('saveProjectAiProviders', async (params: {
    providers: AIProviderSettings[],
    projectId: string | undefined
}) => {
    const response = axios.post(`${host}/ai/project/providers`, params.providers, {
        headers: headers(params.projectId)
    })
    return response.then((response) => response.data)
})


export const aiSlice = createSlice({
    name: 'ai',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(loadAiSettings.fulfilled, (state, action) => {
                state.aiProviderSettings = action.payload
            })
            .addCase(saveAiSettings.fulfilled, (state, action) => {
                state.aiProviderSettings = action.payload
            })
            .addCase(loadProjectAiProviders.fulfilled, (state, action) => {
                state.projectAiProviderSettings = action.payload
            })
            .addCase(saveProjectAiProviders.fulfilled, (state, action) => {
                state.projectAiProviderSettings = action.payload
            })

    }
})


export default aiSlice.reducer;